const rankingItems = [
  {
    tag: '爆',
    tagClass: 'bg-accent-500 text-background-50',
    title: '某顶流明星私密聚会照片流出，圈内人士集体沉默',
  },
  {
    tag: '热',
    tagClass: 'bg-primary-500 text-background-50',
    title: '深度调查：某知名企业财务造假内幕全揭秘',
  },
  {
    tag: '热',
    tagClass: 'bg-primary-500 text-background-50',
    title: '独家：年度最大规模数据泄露事件始末追踪',
  },
  {
    tag: '新',
    tagClass: 'bg-secondary-500 text-background-50',
    title: '娱乐圈再爆大瓜，某当红艺人疑似隐婚生子',
  },
  {
    tag: '新',
    tagClass: 'bg-secondary-500 text-background-50',
    title: '某直播平台头部主播偷税案最新进展曝光',
  },
  {
    tag: '热',
    tagClass: 'bg-primary-500 text-background-50',
    title: '内部人士爆料：某互联网大厂即将大规模裁员',
  },
  {
    tag: '爆',
    tagClass: 'bg-accent-500 text-background-50',
    title: '某知名品牌食品安全问题被监管部门立案调查',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          今日热榜
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          实时热度排行 · 持续更新
        </p>
        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-3 md:gap-4 py-3.5 border-b border-background-200/70 last:border-0 hover:bg-background-50 transition-colors duration-150 group cursor-pointer"
            >
              <span className={`font-heading font-bold text-lg md:text-xl w-8 text-center shrink-0 ${
                i < 3 ? 'text-accent-500' : 'text-foreground-400'
              }`}>
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className={`shrink-0 text-[10px] font-bold px-2 py-0.5 rounded whitespace-nowrap ${item.tagClass}`}>
                {item.tag}
              </span>
              <span className="text-foreground-800 text-sm md:text-base leading-snug group-hover:text-primary-600 transition-colors flex-1 line-clamp-1">
                {item.title}
              </span>
              <span className="shrink-0 text-foreground-400 text-xs">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}